// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-blog-template-tsx": require("gatsby-module-loader?name=component---src-templates-blog-template-tsx!/opt/build/repo/src/templates/blogTemplate.tsx"),
  "component---src-pages-404-tsx": require("gatsby-module-loader?name=component---src-pages-404-tsx!/opt/build/repo/src/pages/404.tsx"),
  "component---src-pages-about-tsx": require("gatsby-module-loader?name=component---src-pages-about-tsx!/opt/build/repo/src/pages/about.tsx"),
  "component---src-pages-blog-tsx": require("gatsby-module-loader?name=component---src-pages-blog-tsx!/opt/build/repo/src/pages/blog.tsx"),
  "component---src-pages-index-tsx": require("gatsby-module-loader?name=component---src-pages-index-tsx!/opt/build/repo/src/pages/index.tsx"),
  "component---src-pages-modules-deeper-tsx": require("gatsby-module-loader?name=component---src-pages-modules-deeper-tsx!/opt/build/repo/src/pages/modules/Deeper.tsx"),
  "component---src-pages-testpage-tsx": require("gatsby-module-loader?name=component---src-pages-testpage-tsx!/opt/build/repo/src/pages/testpage.tsx")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "blog-welcome.json": require("gatsby-module-loader?name=path---blog-welcome!/opt/build/repo/.cache/json/blog-welcome.json"),
  "404.json": require("gatsby-module-loader?name=path---404!/opt/build/repo/.cache/json/404.json"),
  "about.json": require("gatsby-module-loader?name=path---about!/opt/build/repo/.cache/json/about.json"),
  "blog.json": require("gatsby-module-loader?name=path---blog!/opt/build/repo/.cache/json/blog.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/opt/build/repo/.cache/json/index.json"),
  "modules-deeper.json": require("gatsby-module-loader?name=path---modules-deeper!/opt/build/repo/.cache/json/modules-deeper.json"),
  "testpage.json": require("gatsby-module-loader?name=path---testpage!/opt/build/repo/.cache/json/testpage.json"),
  "404-html.json": require("gatsby-module-loader?name=path---404-html!/opt/build/repo/.cache/json/404-html.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-tsx!/opt/build/repo/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js